import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 1rem;
  justify-content: flex-end;

  padding-top: 1rem;
  border-top: 1px solid #bbbbbb;

  @media (min-width: 600px) {
    button {
      width: fit-content;
    }
  }
`;
